package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf

data class FavoritesPageUIState(
    val favorites: ImmutableList<HomeTopPickUiModel> = persistentListOf(),
    val isLoading: Boolean = false
)

